import { ReactComponent as ImageIcon } from 'Assets/icons/image.svg';
import { SharedItemAuthorCell } from 'Modules/sharedItems/components/SharedItemAuthorCell';
import { SharedItemRowProps } from 'Modules/sharedItems/components/SharedItemRow/index.types';
import { SHARED_ITEMS_GRID_COLS } from 'Modules/sharedItems/index.constants';
import { formatSharedItemDate, getSharedItemIcon } from 'Modules/sharedItems/utils';
import React from 'react';
import { cn } from '~/lib/utils';

export const SharedItemRow: React.FC<SharedItemRowProps> = ({
  item,
  onOpenItem,
}) => {
  const isDisabled = item.isUnavailable;
  const icon = getSharedItemIcon(item);
  const canOpen = !isDisabled && (!!item.targetUrl || !!item.fileInfoId);

  const handleNameClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (!canOpen) {
      return;
    }
    onOpenItem(item);
  };

  return (
    <div
      role="row"
      className={cn(
        'grid items-center gap-4 border-b border-border px-4 py-3 hover:bg-muted',
        SHARED_ITEMS_GRID_COLS,
        isDisabled && 'opacity-50'
      )}
      data-testid={`shared-item-row-${item.id}`}
    >
      <div role="cell" className="flex min-w-0 items-center gap-3">
        <div className="flex h-[36px] w-[36px] shrink-0 items-center justify-center rounded-full border border-muted-border bg-muted">
          {icon.kind === 'image' ? (
            <ImageIcon className="h-[18px] w-[18px] text-primary" />
          ) : (
            <img
              src={icon.src}
              alt=""
              className="h-[18px] w-[18px] object-contain"
            />
          )}
        </div>
        <div className="min-w-0">
          <button
            type="button"
            className={cn(
              'block max-w-full truncate text-[14px] font-bold leading-[22px]',
              canOpen && 'cursor-pointer hover:underline'
            )}
            onClick={handleNameClick}
            disabled={!canOpen}
            data-testid={`shared-item-name-${item.id}`}
          >
            {item.itemDisplayName}
          </button>
        </div>
      </div>
      <div role="cell" className="min-w-0">
        <SharedItemAuthorCell author={item.author} />
      </div>
      <div
        role="cell"
        className="truncate text-[14px] leading-[21px] text-secondary"
      >
        {formatSharedItemDate(item.sharedAt)}
      </div>
    </div>
  );
};
